import { render, staticRenderFns } from "./SmartStudentId.vue?vue&type=template&id=25020b80&scoped=true"
import script from "./SmartStudentId.vue?vue&type=script&lang=js"
export * from "./SmartStudentId.vue?vue&type=script&lang=js"
import style0 from "./SmartStudentId.vue?vue&type=style&index=0&id=25020b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25020b80",
  null
  
)

export default component.exports